(function () {
  function formatMoney(cents, format) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(cents / 100));
    var amountWithComma = amount.replace('.', ',');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function parseVariantsScript(sectionId) {
    var el = document.getElementById('ProductVariants-' + sectionId);
    if (!el || !el.textContent) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function getOptionsFromForm(form, optionCount) {
    var opts = [null, null, null];
    for (var i = 1; i <= optionCount; i++) {
      var checked = form.querySelector('input[name="option-' + i + '"]:checked');
      opts[i - 1] = checked ? checked.value : null;
    }
    return opts;
  }

  function findVariant(variants, opts) {
    return variants.find(function (v) {
      return (
        (v.option1 || null) === (opts[0] || null) &&
        (v.option2 || null) === (opts[1] || null) &&
        (v.option3 || null) === (opts[2] || null)
      );
    });
  }

  function setGalleryActive(root, mediaId) {
    if (!mediaId) return;
    var slides = root.querySelectorAll('[data-gallery-main] .product-gallery__slide');
    slides.forEach(function (slide) {
      var id = slide.getAttribute('data-media-id');
      if (id === String(mediaId)) {
        slide.classList.add('is-active');
        slide.removeAttribute('hidden');
        var img = slide.querySelector('img');
        if (img && img.getAttribute('loading') === 'lazy') {
          img.setAttribute('loading', 'eager');
        }
      } else {
        slide.classList.remove('is-active');
        slide.setAttribute('hidden', '');
      }
    });
    root.querySelectorAll('[data-gallery-thumbs] .product-gallery__thumb').forEach(function (btn) {
      var bid = btn.getAttribute('data-thumb-id');
      if (bid === String(mediaId)) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'true');
      } else {
        btn.classList.remove('is-active');
        btn.removeAttribute('aria-current');
      }
    });
  }

  function updateLabels(form, variant, optionCount) {
    for (var i = 1; i <= optionCount; i++) {
      var label = form.querySelector('[data-option-label-' + i + ']');
      if (label && variant) {
        var val = variant['option' + i];
        if (val) label.textContent = val;
      }
    }
  }

  function optionValueAvailable(variants, position, value, selected) {
    return variants.some(function (v) {
      if (!v.available) return false;
      for (var i = 1; i <= 3; i++) {
        var key = 'option' + i;
        if (i === position) {
          if ((v[key] || null) !== (value || null)) return false;
        } else if (selected[i - 1]) {
          if ((v[key] || null) !== (selected[i - 1] || null)) return false;
        }
      }
      return true;
    });
  }

  function refreshOptionDisabledStates(form, variants, optionCount) {
    var selected = [];
    for (var i = 1; i <= optionCount; i++) {
      var inp = form.querySelector('input[name="option-' + i + '"]:checked');
      selected.push(inp ? inp.value : null);
    }
    for (var p = 1; p <= optionCount; p++) {
      form.querySelectorAll('input[name="option-' + p + '"]').forEach(function (input) {
        var label = input.closest('.product-option__choice');
        if (!label) return;
        var ok = optionValueAvailable(variants, p, input.value, selected);
        label.classList.toggle('is-unavailable', !ok);
        input.disabled = !ok && !input.checked;
      });
    }
  }

  function applyVariant(root, form, variant, variants, moneyFormat, strings, optionCount) {
    var hidden = form.querySelector('[data-variant-id-input]');
    var select = form.querySelector('[data-variant-select]');
    var priceEl = root.querySelector('[data-product-price]');
    var btn = form.querySelector('[data-add-to-cart]');
    var badges = root.querySelector('[data-product-badges]');
    var skuRow = root.querySelector('[data-product-sku-row]');
    var skuVal = root.querySelector('[data-product-sku]');
    var invEl = root.querySelector('[data-product-inventory]');
    var invThreshold = invEl ? parseInt(invEl.getAttribute('data-inventory-threshold'), 10) || 8 : 8;

    if (!variant) {
      if (hidden) hidden.value = '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = strings.unavailable;
      }
      return;
    }

    if (hidden) hidden.value = String(variant.id);
    if (select) select.value = String(variant.id);

    if (priceEl) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html +=
          '<s class="price__compare">' +
          formatMoney(variant.compare_at_price, moneyFormat) +
          '</s> ';
        html += '<span class="price__sale">' + formatMoney(variant.price, moneyFormat) + '</span>';
      } else {
        html = '<span class="price__regular">' + formatMoney(variant.price, moneyFormat) + '</span>';
      }
      priceEl.innerHTML = '<div class="price" data-price>' + html + '</div>';
    }

    if (badges) {
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      badges.innerHTML = onSale
        ? '<span class="product-badge product-badge--sale">' + strings.sale + '</span>'
        : '';
    }

    if (btn) {
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? strings.addToCart : strings.soldOut;
    }

    if (skuRow && skuVal) {
      if (variant.sku) {
        skuVal.textContent = variant.sku;
        skuRow.removeAttribute('hidden');
      } else {
        skuRow.setAttribute('hidden', '');
      }
    }

    if (invEl) {
      var showInv =
        variant.inventory_management &&
        variant.inventory_quantity > 0 &&
        variant.inventory_quantity <= invThreshold;
      if (showInv) {
        var tmpl = strings.lowStock || 'Only __COUNT__ left';
        invEl.textContent = tmpl.replace('__COUNT__', String(variant.inventory_quantity));
        invEl.removeAttribute('hidden');
      } else {
        invEl.textContent = '';
        invEl.setAttribute('hidden', '');
      }
    }

    setGalleryActive(root, variant.featured_media_id);
    updateLabels(form, variant, optionCount);

    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', u.toString());
    } catch (e) {}
  }

  function initQuantity(form) {
    var input = form.querySelector('[data-quantity-input]');
    if (!input) return;
    var dec = form.querySelector('[data-qty-decrease]');
    var inc = form.querySelector('[data-qty-increase]');
    function clamp() {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > 999) v = 999;
      input.value = String(v);
    }
    if (dec)
      dec.addEventListener('click', function () {
        input.value = String(Math.max(1, parseInt(input.value, 10) - 1 || 1));
        clamp();
      });
    if (inc)
      inc.addEventListener('click', function () {
        input.value = String(Math.min(999, (parseInt(input.value, 10) || 1) + 1));
        clamp();
      });
    input.addEventListener('change', clamp);
  }

  function initGalleryThumbs(root) {
    var thumbs = root.querySelector('[data-gallery-thumbs]');
    if (!thumbs) return;
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-thumb-id]');
      if (!btn) return;
      var id = btn.getAttribute('data-thumb-id');
      setGalleryActive(root, id);
    });
  }

  function initShare(root, copiedMessage) {
    var btn = root.querySelector('.product-share__btn[data-share-url]');
    var feedback = root.querySelector('[data-share-feedback]');
    if (!btn || !navigator.clipboard) return;
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-share-url');
      navigator.clipboard.writeText(url).then(
        function () {
          if (feedback) {
            feedback.textContent = copiedMessage || '';
            feedback.classList.add('is-visible');
            window.setTimeout(function () {
              feedback.textContent = '';
              feedback.classList.remove('is-visible');
            }, 2200);
          }
        },
        function () {}
      );
    });
  }

  function initProduct(root) {
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;
    var form = root.querySelector('.product-form');
    if (!form) return;
    var variants = parseVariantsScript(sectionId);
    if (!variants.length) variants = [];

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var optionCount = 0;
    for (var i = 1; i <= 3; i++) {
      if (form.querySelector('input[name="option-' + i + '"]')) optionCount = i;
    }

    var strings = {
      addToCart: root.getAttribute('data-str-add') || 'Add to cart',
      soldOut: root.getAttribute('data-str-sold') || 'Sold out',
      unavailable: root.getAttribute('data-str-unavailable') || 'Unavailable',
      sale: root.getAttribute('data-str-sale') || 'Sale',
      lowStock: root.getAttribute('data-str-low-stock') || 'Only __COUNT__ left',
    };

    var shareDone = root.getAttribute('data-share-done') || '';

    initQuantity(form);
    initGalleryThumbs(root);
    initShare(root, shareDone);

    if (!variants.length) return;

    function syncFromOptions() {
      var opts = getOptionsFromForm(form, optionCount);
      var v = findVariant(variants, opts);
      refreshOptionDisabledStates(form, variants, optionCount);
      applyVariant(root, form, v, variants, moneyFormat, strings, optionCount);
    }

    function syncFromSelect() {
      var select = form.querySelector('[data-variant-select]');
      if (!select) return;
      var id = parseInt(select.value, 10);
      var v = variants.find(function (x) {
        return x.id === id;
      });
      applyVariant(root, form, v, variants, moneyFormat, strings, optionCount);
    }

    form.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var pos = parseInt(input.name.replace('option-', ''), 10);
        form.querySelectorAll('input[name="' + input.name + '"]').forEach(function (r) {
          var lab = r.closest('.product-option__choice');
          if (lab) lab.classList.toggle('is-selected', r.checked);
        });
        syncFromOptions();
      });
    });

    var variantSelect = form.querySelector('[data-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', syncFromSelect);
    }

    if (optionCount > 0) {
      refreshOptionDisabledStates(form, variants, optionCount);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
  });
})();
